import BigNumber from 'bignumber.js';
export const bn = (n, base = 10) => new BigNumber(n, base);
export const bnOrZero = (n) => {
    const value = bn(n || 0);
    return value.isNaN() ? bn(0) : value;
};
